// src/utils/session.js
const KEY = "jwt_token";

// Bypass DEV du SSO (uniquement pour prévisualiser l'UI en local sans backend).
//
// Piloté par `.env.local` (gitignoré) et non plus par une constante à basculer
// à la main : une valeur en dur se committait à `true` un jour ou l'autre.
// Ici, deux verrous rendent la chose impossible à déployer :
//   - `NODE_ENV` que CRA fige à "production" dans un build ;
//   - la variable elle-même, absente du dépôt.
//
// Activation locale : REACT_APP_DEV_BYPASS_AUTH=1 dans .env.local, puis
// redémarrage du serveur de dev (les variables sont lues à la compilation).
const DEV_BYPASS_AUTH =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_DEV_BYPASS_AUTH === "1";

export function getJwtToken() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}
export function setJwtToken(t) {
  try { t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY); } catch {}
}
export function clearJwtToken() { setJwtToken(""); }

// Vrai si le bypass DEV est actif (évite les redirections /sso en local sans backend).
export function isAuthBypassed() {
  return DEV_BYPASS_AUTH;
}

export function isAuthenticated() {
  if (DEV_BYPASS_AUTH) return true; // ⚠️ DEV ONLY
  const t = getJwtToken();
  return !!t && t.length > 10; // assez long pour un JWT
}

export function requireAuth() {
  if (DEV_BYPASS_AUTH) return "dev-bypass"; // ⚠️ DEV ONLY
  const t = getJwtToken();
  if (!t) throw new Error("NO_AUTH");
  return t;
}

// (optionnel) si un jour tu poses un cookie SSO côté backend
export function hasAnySSOCookie() {
  return document.cookie.split(";").some(c => /fm_sso=1/.test(c));
}
